import { isLifecycleRunning } from '../../utils/lifecyclePhaseFilter';

/**
 * Whether a card's approve/reject icons are live.
 *
 * An approval that belongs to no lifecycle phase is not gated by any of this. A
 * lifecycle approval is actionable while its phase is the current one AND its lifecycle
 * is still running, unless the caller says otherwise. A failed or completed lifecycle
 * leaves its last phase IsCurrent, so the phase alone does not settle it. #35357
 *
 * `enableApprovalButton` defaults to true because omitting it used to disable the
 * card: only the lifecycle tab ever passed it, so the My Work board's approvals lane
 * rendered every lifecycle approval with dead icons. The ticket's own approvals list
 * escaped it only because EditTicketForm feeds it non-lifecycle approvals. #35290
 */
export const isApprovalActionEnabled = (
  isLifecycleEnabled: boolean,
  approval: Approval,
  enableApprovalButton: boolean = true,
  lifecycleStatusGuid?: string
): boolean => {
  const phase = approval?.TicketLifecyclePhase;

  if (!isLifecycleEnabled || phase == undefined) return true;

  return !!phase.IsCurrent && isLifecycleRunning(lifecycleStatusGuid) && enableApprovalButton;
};
